module.exports = __webpack_public_path__ + "img/logo.a3427347.png";